import axios, { AxiosInstance as Axios } from 'axios';

export let authenticatedAxios: Axios = axios.create({ withCredentials: false });

export const updateAxiosToken = (getAccessToken?: () => Promise<string>) => {
    const id = authenticatedAxios.interceptors.request.use(
        async config => {
            const accessToken = await getAccessToken?.();

            config.headers.set('Authorization', `Bearer ${accessToken}`);
            config.headers.set('Accept', 'application/json');

            return config;
        },
        error => {
            Promise.reject(error);
        }
    );

    return () => authenticatedAxios.interceptors.request.eject(id);
};
